import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const Navigation: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  if (!user) return null;

  return (
    <div className="bg-william-800 text-white">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center">
          <div className="text-xl font-bold mr-8">BasiQR</div>

          <nav className="hidden md:flex space-x-1">
            <Link
              to="/workspace"
              className={`px-3 py-2 rounded ${isActive('/workspace')
                ? 'bg-william-700 text-white'
                : 'text-william-100 hover:bg-william-700/50'
                }`}
            >
              Workspace
            </Link>
          </nav>
        </div>

        <div className="flex items-center space-x-4">
          <div className="hidden md:block text-sm text-william-100">{user.username}</div>

          <button
            onClick={() => logout()}
            className="px-3 py-1.5 text-sm bg-william-700 text-white rounded hover:bg-william-600 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden border-t border-william-700">
        <div className="container mx-auto px-4 py-2 flex justify-around">
          <Link
            to="/workspace"
            className={`px-4 py-2 text-center flex-1 ${isActive('/workspace')
              ? 'text-white border-b-2 border-william-400'
              : 'text-william-200'
              }`}
          >
            Workspace
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
